/* eslint-disable */
/* eslint-disable sonarjs/no-use-of-empty-return-value */
/* eslint-disable sonarjs/no-identical-functions */
/* eslint-disable sonarjs/no-unused-collection */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable no-console */
import React from 'react';
import { useState, useEffect, useContext } from 'react';
import { useHistory, useParams, useLocation } from 'react-router-dom'; //useLocation
import {
  RACButton,
  Grid,
  RACModalCard,
  Typography,
  RACTooltip,
  CircularProgress,
} from '@rentacenter/racstrap';
import AddCocustomer from '../AddCoCustomer/AddCocustomer';
import { AgreementContext } from '../../../context/AgreementContext';
import { AppRoute } from '../../../config/route-config';
import { ReactComponent as AlterIcon } from '../../../assets/images/Alert-1.svg';
import {
  AccountManagementURLParam,
  ADD_ON_PACKAGE,
  AMOrigin,
  customerReferenceValidation,
  CHANNEL,
  PROMOTION_LEASE_TYPE_RTO,
  PROMOTION_LOB,
} from '../../../constants/constants';
import { OriginContext } from '../../../context/OriginContext';
import { Usercontext } from './searchResult';
import { FeatureFlagContext } from '../../../context/FeatureFlagContext';
import { ReactComponent as Info } from '../../../assets/images/info-tooltip.svg';
import { useTranslation } from 'react-i18next';
import { GetCustomerEligiblePromotion, RunDE } from '../../../api/user';
import SecondFactor from '../TwoFactorPopup/TwoFactorPopup';
import { buildBasicInformation } from '../../../utils/skipTraceUtils';
import { CustomerEligiblePromotionsRequest } from '../../../utils/rewardsUtilsInterface';

interface Params {
  customerId: string;
  agreementId: string;
}


const FooterContent = (props: any) => {
  const {
    agreementVoidStatus,
    agreementCreateStatus,
    itemArrayData,
    setinventoryMapping,
    setPackageRules,
    storeSelectedPackagePriceTag,
    getCustomerResponse,
    isMotorcycleAdded,
    noOfInv,
    addItemSearch,
    coworkerRole,
    overrideReason, setOverrideReason,
    dEResponse, setDEResponse, allItemsAllowed,
    addGetItemPrice,
    setCustomerPromotions,
    customerTierDetails,
    rmsItemNumbers,
    setCustomerTierCodes,
    promocodeInventoryNumber,
    agreementRateTerm
  } = useContext(AgreementContext);
  const { redirectOrigin } = useContext(OriginContext);
  const classes = props.throwStyle;
  const { featureFlagDetails } = useContext(FeatureFlagContext)
  const location = useLocation();
  const search = useLocation().search;
  const salesLeadId = new URLSearchParams(search).get('salesLeadId');
  const [referenceDetails, setReferenceDetails] = useState<any>({})
  const shareData: any = useContext(Usercontext);
  const history = useHistory();
  const [footerControl, setfooterControl] = useState();
  const [packageCriteriaFooter, setpackageCriteriaFooter]: any = useState();
  const [copyData, setcopyData]: any = useState();
  const [showReferenceWarning, setShowReferenceWarning] = useState(false);
  // const { customerId } = useParams<Params>();
  let { agreementId } = useParams<Params>();
  const { customerId } = useParams<Params>();
  if (redirectOrigin === AMOrigin) {
    agreementId = agreementId.replace(AccountManagementURLParam, '');
  }
  const [SecondFactorEnabled, setSecondFactorEnabled] = useState(false);
  const [declinePopUp, setDeclinePopUp] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [coCustomerId, setcocustomerId] = useState('');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [coCustomerName, setcoCustomerName] = useState('');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [newcustomer, setnewcustomer] = useState(true);
  const [openPackageSelection, setopenPackageSelection] = useState(false);
  const [dEPopUpOpen, setDEPopUpOpen] = useState({
    dEpopUp: false,
    dEApproved: false,
    dEDeclined: false,
    dEOverride: false,
    dEReason: false,
    error: false,
    overrideLimitExceeded: false
  });
  const [approvalStatus, setApprovalStatus] = useState<any>(null)
  const [remainingValue, setRemainingValue] = useState<any>(null)
  const [ModuleName, setModuleName] = useState("")
  const [isOverrideLimitExceeded, setIsOverrideLimitExceeded] = useState<boolean>(false);
  const [packageSelection, setpackageSelection] = useState(false);
  const [itemArrayReceived, setitemArrayReceived] = useState([]);
  const [buttonController, setButtonController] = useState(false)
  const loaderObj = {
    Gridloader: true,
    masterLoader: false,
    loaderController: false,
  };
  const [loaderBundle, setLoaderBundle] = useState(loaderObj);
  const { i18n, t } = useTranslation('rental');
  const [customerDecryptData, setCustomerDecryptData] = useState<any>();
  const [overrideApproval, setOverrideApproval] = useState({
    overrideLimit: 0,
    overrideUsed: 0
  })

  useEffect(() => {
    setfooterControl(props.controlData);
    setButtonController(allItemsAllowed)
    setpackageCriteriaFooter(props.throwpackageCriteria);
    setcopyData(props.throwCopy);
    setpackageSelection(props.throwPackageState);
    console.log('props.throwPackageState in footer', props.throwPackageState);

    setitemArrayReceived(props.throwItemArray);
    console.log('props.throwItemArray', props.throwItemArray);
    console.log(featureFlagDetails?.MXRequiredReferenceDetails, "MXDDD")
  }, [props]);

  const SLACancel = () => {
    setSecondFactorEnabled(false);
    if (declinePopUp) {
      setDeclinePopUp(false)
      setDEPopUpOpen({ ...dEPopUpOpen, dEpopUp: false, dEApproved: false, dEDeclined: false, dEOverride: false, dEReason: false, overrideLimitExceeded: false })
    }
    else {
      setDEPopUpOpen({ ...dEPopUpOpen, dEpopUp: true, dEApproved: false, dEDeclined: false, dEOverride: false, dEReason: true, overrideLimitExceeded: false })
    }
  };

  const SLAClose = (value: boolean) => {
    if (value) {
      setSecondFactorEnabled(false);
      if (declinePopUp) {
        setDeclinePopUp(false)
        setDEPopUpOpen({ ...dEPopUpOpen, dEpopUp: false, dEApproved: false, dEDeclined: false, dEOverride: false, dEReason: false, overrideLimitExceeded: false })
      }
      else {
        setDEPopUpOpen({ ...dEPopUpOpen, dEpopUp: true, dEApproved: false, dEDeclined: false, dEOverride: false, dEReason: true, overrideLimitExceeded: false })
      }
    }
  };

  const SLACompleted = () => {
    setSecondFactorEnabled(false);
    if (declinePopUp) {
      setDeclinePopUp(false)
      approvalOkFn()
    }
    else {
      nonMxStoreFn()
    }
  };

  useEffect(() => {
    if (featureFlagDetails?.MXRequiredReferenceDetails) {
      let ReferenceDetails = JSON.parse(featureFlagDetails?.MXRequiredReferenceDetails)
      setReferenceDetails(ReferenceDetails)
    }
  }, [])

  async function decryption() {
    console.log(getCustomerResponse, 'getCustomerResponse in footer')
    const encryptedValue = await buildBasicInformation(getCustomerResponse?.GetCustomer?.value, true);
    console.log(encryptedValue, 'encryptedValue in footer')
    setCustomerDecryptData(encryptedValue)
    return encryptedValue;
  }
  console.log(addGetItemPrice, 'addGetItemPrice')
  useEffect(() => {
    const overrideUsedCount = addGetItemPrice?.dEOverrideUsedCount || 0;
    const overrideLimit = featureFlagDetails?.DEOverrideLimit || 0;
    const overrideAllowableCount = Math.max(overrideLimit - overrideUsedCount, 0);
    setOverrideApproval({
      ...overrideApproval, overrideLimit: overrideLimit || 0,
      overrideUsed: overrideAllowableCount
    })
  }, [addGetItemPrice])

  useEffect(() => {
    if (dEResponse) {
      const dEApprovalStatus = dEResponse.approvalResponse;
      setApprovalStatus(dEApprovalStatus)
      if (dEApprovalStatus == 'preapproved') {
        setDEPopUpOpen({ ...dEPopUpOpen, dEpopUp: true, dEApproved: true, dEDeclined: false, dEOverride: false, dEReason: false })
      } else {
        setDEPopUpOpen({ ...dEPopUpOpen, dEpopUp: true, dEApproved: false, dEDeclined: true, dEOverride: false, dEReason: false })
      }
    }
  }, [dEResponse]);

  const pull_data = (data) => {
    setcocustomerId(data.coCustomerId);
    setcoCustomerName(data.coCustomerName);
    props.func({
      coCustomerId: data.coCustomerId,
      coCustomerName: data.coCustomerName,
    });
    // eslint-disable-next-line no-console
    console.log('Footer contex', data); // LOGS DATA FROM CHILD (My name is Dean Winchester... &)
  };

  const CancelClick = () => {
    if (redirectOrigin === AMOrigin) {
      history.push({
        pathname: `${AppRoute.AMCustomer}/${customerId}`,
        state: location?.state,
      });
      return;
    }
    history.push({
      pathname: `/customer/searchcustomer`,
    });
  };

  const invQuantityFormation = (payload: any) => {
    const ResponseArr: any = [];
    for (let i = 0; i < payload.length; i++) {
      const indexOfSameObj = ResponseArr.findIndex(
        (checkObj: any) =>
          checkObj.rmsDepartment == payload[i].rmsDepartment &&
          checkObj.rmsSubDepartment == payload[i].rmsSubDepartment &&
          checkObj.rmsBracket == payload[i].rmsBracket &&
          checkObj.rmsItemMasterId == payload[i].rmsItemMasterId
      );
      if (ResponseArr.length == 0 || indexOfSameObj == -1) {
        ResponseArr.push(payload[i]);
      } else {
        ResponseArr[indexOfSameObj].quantity =
          ResponseArr[indexOfSameObj].quantity + payload[i].quantity;
      }
    }
    return ResponseArr;
  };
  const validateReqWithMaxCriteriaFn = (req: any, Criteria: any) => {
    const criteriaCheck: any = Criteria.map((obj: any) => {
      obj.validateMaxQuantity = obj.maxQuantity;
      return obj
    });

    for (let i = 0; i < criteriaCheck.length; i++) {
      for (let j = 0; j < req.length; j++) {
        if (
          (((criteriaCheck[i].rmsDepartment == req[j].rmsDepartment)) || !criteriaCheck[i].rmsDepartment) &&
          ((criteriaCheck[i].rmsSubDepartment == req[j].rmsSubDepartment) || !criteriaCheck[i].rmsSubDepartment) &&
          ((criteriaCheck[i].rmsBracket == req[j].rmsBracket) || !criteriaCheck[i].rmsBracket) &&
          ((criteriaCheck[i].rmsItemMasterId == req[j].rmsItemMasterId) || !criteriaCheck[i].rmsItemMasterId)
        ) {
          criteriaCheck[i].validateMaxQuantity = criteriaCheck[i].validateMaxQuantity - req[j].quantity;
        }

      }

    }

    console.log("Max validation failed", criteriaCheck.filter((obj: any) => obj.validateMaxQuantity < 0))
    return criteriaCheck.filter((obj: any) => obj.validateMaxQuantity < 0)

  }
  const validateReqWithCriteriaFn = (req: any, Criteria?: any, maxCriteria?: any) => {

    const validateReqWithMinCriteriaFn = (req: any, Criteria: any) => {
      const criteriaCheck: any = Criteria.map((obj: any) => {
        obj.validateMinQuantity = obj.minQuantity;
        return obj
      });

      for (let i = 0; i < criteriaCheck.length; i++) {
        for (let j = 0; j < req.length; j++) {
          if (
            (((criteriaCheck[i].rmsDepartment == req[j].rmsDepartment)) || !criteriaCheck[i].rmsDepartment) &&
            ((criteriaCheck[i].rmsSubDepartment == req[j].rmsSubDepartment) || !criteriaCheck[i].rmsSubDepartment) &&
            ((criteriaCheck[i].rmsBracket == req[j].rmsBracket) || !criteriaCheck[i].rmsBracket) &&
            ((criteriaCheck[i].rmsItemMasterId == req[j].rmsItemMasterId) || !criteriaCheck[i].rmsItemMasterId)
          ) {
            criteriaCheck[i].validateMinQuantity = criteriaCheck[i].validateMinQuantity - req[j].quantity;
          }

        }

      }
      const minQuanityRes = criteriaCheck.filter((obj: any) => obj.validateMinQuantity > 0)
      if (minQuanityRes.length > 0) {
        console.log("Minqunaity failed", minQuanityRes)
        return minQuanityRes
      }
      else {
        console.log("Min qty passed", minQuanityRes)

        return validateReqWithMaxCriteriaFn(req, maxCriteria);

      }

    }
    return validateReqWithMinCriteriaFn(req, Criteria);
  }

  /* New Package Validation Logic Start */
  const validateItems = (cartItems: any, criteria: any) => {
    debugger
    criteria.map((x: any) => {
      x.originalMinQuantity = x.minQuantity;
      x.originalMaxQuantity = x.maxQuantity;
    })
    for (let cartItem of cartItems) {

      for (let criterion of criteria) {
        /* This nested if will assign a match level for the criteria, 1 being the best match and 
         * 4 being the least match
         * Note: Using an if-else won't make sure the sub department exists within that department */
        if (cartItem.rmsDepartment == criterion.rmsDepartment) {
          if (cartItem.rmsSubDepartment == criterion.rmsSubDepartment) {
            if (cartItem.rmsBracket == criterion.rmsBracket) {
              if (cartItem.rmsItemMasterId == criterion.rmsItemMasterId) {
                criterion.matchLevel = 1;
              }
              else if (criterion.rmsItemMasterId == null) {
                criterion.matchLevel = 2;
              }
              else {
                criterion.matchLevel = 6;
              }
            }
            else if (criterion.rmsBracket == null) {
              criterion.matchLevel = 3
            }
            else {
              criterion.matchLevel = 6;
            }
          }
          else if (criterion.rmsSubDepartment == null) {
            criterion.matchLevel = 4
          }
          else {
            criterion.matchLevel = 6;
          }
        }
        else {
          criterion.matchLevel = 6;
        }
      }

      criteria.sort((a: any, b: any) => a.matchLevel - b.matchLevel);

      // console.log("criteria",criteria)

      const matchedIndex: any = criteria.findIndex((x: { maxQuantity: any; matchLevel: any; }) => x.maxQuantity > 0 && x.matchLevel != 6);
      if (matchedIndex > -1) {
        criteria[matchedIndex].minQuantity -= cartItem.quantity; // min quantity should stay negative or 0
        criteria[matchedIndex].maxQuantity -= cartItem.quantity; // max quantity should stay positive or 0
      }
      else {
        criteria[0].minQuantity -= cartItem.quantity;
        criteria[0].maxQuantity -= cartItem.quantity;
      }
    }

    return criteria.filter((x: { minQuantity: any; maxQuantity: any; }) => x.minQuantity > 0 || x.maxQuantity < 0)
  }


  /* New Package Validation Logic  End*/

  const minMaxValidator = () => {
    debugger
    if ((props.throwpackageCriteria || props.givereceivedpackage == ADD_ON_PACKAGE) && copyData) {
      const invDetails: any = [];
      const bucketCopy = copyData;
      const packageCriteria = props.throwpackageCriteria;
      bucketCopy.forEach((obj: any) => {
        //checking items in filtered array
        //item array is empty so we are pushing that item
        invDetails.push({
          rmsDepartment: obj.departmentsEn,
          rmsSubDepartment: obj.subDepartmentsEn,
          rmsBracket: obj.bracketEn,
          rmsItemMasterId: obj.rmsItemMasterId,
          quantity: 1,
        });
      });

      const selectedInvArr = invQuantityFormation(invDetails);

      let maxQtyPackageCriteria: any;
      if (props.givereceivedpackage !== ADD_ON_PACKAGE) {
        maxQtyPackageCriteria = JSON.parse(JSON.stringify(packageCriteria))
        const validPackageCriteria = packageCriteria.filter(
          (obj: any) => obj.minQuantity > 0
        );
      }
      const invalidMinMaxObjArr: any = props.givereceivedpackage == ADD_ON_PACKAGE ? [] : validateItems(selectedInvArr, maxQtyPackageCriteria);

      //console.log('invalidMinMaxObjArr', invalidMinMaxObjArr);
      if (invalidMinMaxObjArr?.length == 0) {
        props.setItemsearchCompleted(true);
        setPackageRules(props.throwpackageCriteria);
        if (salesLeadId == null && agreementId == undefined) {
          history.push({
            pathname: `/agreement/rental/details/${customerId}`,
          });
          const navEvent = new PopStateEvent('popstate');
          window.dispatchEvent(navEvent);
        } else if (salesLeadId == null && agreementId !== undefined) {
          // const Orgin = window.location.origin;
          // window.location.href = `${Orgin}/agreement/rental/details/${customerId}/${agreementId}`;
          history.push({
            pathname: `/agreement/rental/details/${customerId}/${agreementId}`,
          });
          const navEvent = new PopStateEvent('popstate');
          window.dispatchEvent(navEvent);
        } else {
          history.push({
            pathname: `/agreement/rental/details/${customerId}?salesLeadId=${salesLeadId}`,
          });
          const navEvent = new PopStateEvent('popstate');
          window.dispatchEvent(navEvent);
        }
        const store: any = [];
        console.log('itemArrayData from footer context', itemArrayData);
        if (itemArrayData !== undefined) {
          itemArrayData.map((value) => {
            store.push({
              inventoryId: value,
            });
          });
          setinventoryMapping(store);
          console.log('store populate', store);
        }

        // communicate to Routes that URL has changed
        // const navEvent = new PopStateEvent('popstate');
        // window.dispatchEvent(navEvent);
      } else {
        console.log('trigger error popup');
        props.triggerMinMaxPopup(invalidMinMaxObjArr);
      }
    } else if (!props.throwpackageCriteria && copyData.length == 1) {
      props.setItemsearchCompleted(true);
      const store: any = [];
      console.log('itemArrayData from footer context1', itemArrayData);
      if (itemArrayData !== undefined) {
        itemArrayData.map((value) => {
          store.push({
            inventoryId: value,
          });
        });
        setinventoryMapping(store);
        console.log('store populate', store);
      }
      if (salesLeadId == null && agreementId == undefined) {
        history.push({
          pathname: `/agreement/rental/details/${customerId}`,
        });
        const navEvent = new PopStateEvent('popstate');
        window.dispatchEvent(navEvent);
      } else if (salesLeadId == null && agreementId !== undefined) {
        // const Orgin = window.location.origin;
        // window.location.href = `${Orgin}/agreement/rental/details/${customerId}/${agreementId}`;
        history.push({
          pathname: `/agreement/rental/details/${customerId}/${agreementId}`,
        });
        const navEvent = new PopStateEvent('popstate');
        window.dispatchEvent(navEvent);
      } else {
        history.push({
          pathname: `/agreement/rental/details/${customerId}?salesLeadId=${salesLeadId}`,
        });
        const navEvent = new PopStateEvent('popstate');
        window.dispatchEvent(navEvent);
      }


      // communicate to Routes that URL has changed
      // const navEvent = new PopStateEvent('popstate');
      // window.dispatchEvent(navEvent);
    }
    else {
      if (salesLeadId == null && agreementId !== undefined) {
        history.push({
          pathname: `/agreement/rental/details/${customerId}/${agreementId}`,
        });
        const navEvent = new PopStateEvent('popstate');
        window.dispatchEvent(navEvent);
      }
    }
  };

  const triggerME = () => {
    console.log('response in triggerME');

    console.log('fdgshjhshyyuuiiii');
    props.sometrigger();
  };

  //Customer rference Validation

  function nonMxStoreFn() {
    if (packageSelection === false && itemArrayReceived.length > 1) {
      setopenPackageSelection(true);
    } else {
      // history.push({
      //   pathname: `/agreement/rental/details/${customerId}/${agreementId}`,
      // });
      // const navEvent = new PopStateEvent('popstate');
      minMaxValidator();
    }
  }
  const submitBtnClick = () => {
    // Check if override limit is exceeded
    if (overrideApproval.overrideUsed == 0) {
      // Show confirmation popup before proceeding with SLA
      setDEPopUpOpen({ ...dEPopUpOpen, dEpopUp: false, dEApproved: false, dEDeclined: false, dEOverride: false, dEReason: false, overrideLimitExceeded: true })
    } else {
      // Proceed directly with SLA - override limit NOT exceeded
      setModuleName("DE Override")
      setIsOverrideLimitExceeded(false)
      setSecondFactorEnabled(true)
      setDEPopUpOpen({ ...dEPopUpOpen, dEpopUp: false, dEApproved: false, dEDeclined: false, dEOverride: false, dEReason: false, overrideLimitExceeded: false })
    }
  }
  const NextBtnClick = async () => {
    // const captureObjectIndex: any = [];
    console.log('packageSelection in next click', packageSelection);
    console.log(
      'itemArrayReceived.length in next click',
      itemArrayReceived.length
    );

    let promotionRequest: CustomerEligiblePromotionsRequest
    const storeNumber: string | null = sessionStorage.getItem('storeNumber');

    if (customerTierDetails?.memberStatus == 'Active' && featureFlagDetails?.EnableSponsorPromotion == "1") {
      promotionRequest = {
        storeNumber: storeNumber,
        channel: CHANNEL,
        leaseType: PROMOTION_LEASE_TYPE_RTO,
        lob: PROMOTION_LOB,
        customer: {
          globalCustomerId: getCustomerResponse?.GetCustomer?.value?.globalCustomerId,
          tier: customerTierDetails.memberTiers.loyaltyMemberTier,
        },
        productInfo: {
          storeNumber: storeNumber,
          rmsItemNumbers: rmsItemNumbers,
          inventoryNumbers: promocodeInventoryNumber,
          agreementRateTerm: agreementRateTerm
        }
      }
      setLoaderBundle({ ...loaderBundle, masterLoader: true });
      console.log("promotionRequest: ", promotionRequest);
      const eligiblePromotions = await GetCustomerEligiblePromotion(promotionRequest)
      setLoaderBundle({ ...loaderBundle, masterLoader: false });
      console.log("promotionResponse: ", eligiblePromotions);

      const promotions = eligiblePromotions?.data?.promotions || null
      const customerTierCodes = eligiblePromotions?.data?.CustomerTierCodes || null;
      setCustomerTierCodes(customerTierCodes)
      setCustomerPromotions(promotions)
    }

    if (featureFlagDetails?.EnableCustomerPromotions == "1" && customerTierDetails?.memberStatus != 'Active') {
      promotionRequest = {
        storeNumber: storeNumber,
        channel: CHANNEL,
        leaseType: PROMOTION_LEASE_TYPE_RTO,
        lob: PROMOTION_LOB,
        customer: {
          globalCustomerId: getCustomerResponse?.GetCustomer?.value?.globalCustomerId,
          tier: null
        },
        productInfo: {
          storeNumber: storeNumber,
          rmsItemNumbers: rmsItemNumbers,
          inventoryNumbers: promocodeInventoryNumber,
          agreementRateTerm: agreementRateTerm
        }
      }

      setLoaderBundle({ ...loaderBundle, masterLoader: true });
      console.log("promotionRequest: ", promotionRequest);
      const eligiblePromotions = await GetCustomerEligiblePromotion(promotionRequest)
      setLoaderBundle({ ...loaderBundle, masterLoader: false });
      console.log("promotionResponse: ", eligiblePromotions);

      const promotions = eligiblePromotions?.data?.promotions || null
      const customerTierCodes = eligiblePromotions?.data?.CustomerTierCodes || null;
      setCustomerTierCodes(customerTierCodes)
      setCustomerPromotions(promotions)
    }


    const validation = featureFlagDetails?.MXStoreIdentifier == "1" ? await customerReferenceValidation(getCustomerResponse, isMotorcycleAdded, referenceDetails) : true;
    if (validation) {
      if (Number(featureFlagDetails?.MXDecisionEngine) == 1) {
        setLoaderBundle({ ...loaderBundle, masterLoader: true });
        const decrypteData = await decryption();
        const dERequest = transformDERequest(getCustomerResponse, decrypteData);
        const runDEResponse: any = await RunDE(dERequest);
        console.log(runDEResponse, 'runDEResponse')
        setLoaderBundle({ ...loaderBundle, masterLoader: false });
        if (runDEResponse?.status == 200 && runDEResponse?.data) {
          setDEResponse(runDEResponse.data);
        } else {
          setDEPopUpOpen({ ...dEPopUpOpen, dEpopUp: true, dEApproved: false, dEDeclined: false, error: true })
        }
      }
      else {
        nonMxStoreFn()
      }
    }
    else {
      setShowReferenceWarning(true);
    }
    // let packageMapper = props.throwpackageCriteria;
    // if (packageMapper !== undefined && packageMapper !== null) {
    //   const result = packageMapper.map(function (obj) {
    //     return Object.keys(obj).reduce(function (r, key) {
    //       const k = key.includes('minQuantity') ? 'minPackageQuantity' : key;
    //       const l = key.includes('maxQuantity') ? 'maxPackageQuantity' : key;

    //       r[k] = obj[key];
    //       r[l] = obj[key];

    //       return r;
    //     }, {});
    //   });

    //   packageMapper = result;

    //   console.log('renamed object', result);
    // }

    // // console.log('props.throwpackageCriteria', props.throwpackageCriteria);
    // if (
    //   packageMapper !== undefined &&
    //   packageMapper !== null &&
    //   copyData !== undefined
    // ) {
    //   console.log('packageMapper in footer', packageMapper);
    //   console.log('props.throwCopy in footer', copyData);
    //   copyData.map((cpyObj: any) => {
    //     console.log('cpyObj.departmentsEn', cpyObj.departmentsEn);
    //     packageMapper.map((pkgObj: any) => {
    //       console.log('pkgObj.rmsDepartment', pkgObj.rmsDepartment);
    //       console.log('pkgObj.rmsSubDepartment', pkgObj.rmsSubDepartment);
    //       console.log('pkgObj.rmsBracket', pkgObj.rmsBracket);
    //       if (
    //         (pkgObj.rmsDepartment == null ||
    //           cpyObj.departmentsEn == pkgObj.rmsDepartment) &&
    //         (pkgObj.rmsSubDepartment == null ||
    //           cpyObj.subDepartmentsEn == pkgObj.rmsSubDepartment) &&
    //         (pkgObj.rmsBracket == null ||
    //           cpyObj.bracketEn == pkgObj.rmsBracket) &&
    //         (pkgObj.rmsItemMasterId == null ||
    //           cpyObj.rmsItemMasterId == pkgObj.rmsItemMasterId)
    //       ) {
    //         console.log('reached decrement');
    //         console.log('cpyObj.departmentsEn', cpyObj.departmentsEn);
    //         console.log('pkgObj.rmsBracket', pkgObj.rmsBracket);
    //         console.log('pkgObj.rmsItemMasterId', pkgObj.rmsBracket);
    //         pkgObj.minPackageQuantity = pkgObj.minPackageQuantity - 1;
    //         pkgObj.maxPackageQuantity = pkgObj.maxPackageQuantity - 1;
    //       }
    //     });
    //   });
    //   console.log('data inside package mapper', packageMapper);
    // }

    // if (packageMapper !== undefined && packageMapper !== null) {
    //   console.log('packageMapper', packageMapper);
    //   packageMapper.map((pkgObj: any, pkgIndex: any) => {
    //     if (pkgObj.minPackageQuantity > 0 || pkgObj.maxPackageQuantity < 0) {
    //       captureObjectIndex.push(pkgIndex);
    //     }
    //   });
    // }

    // console.log('captureObjectIndex.data', captureObjectIndex);
    // if (captureObjectIndex.length == 0) {
    //   props.setItemsearchCompleted(true);
    //   if (salesLeadId == null && agreementId == undefined) {
    //     history.push({ pathname: `/agreement/rental/details/${customerId}` });
    //     const navEvent = new PopStateEvent('popstate');
    //     window.dispatchEvent(navEvent);
    //   } else if (salesLeadId == null && agreementId !== undefined) {
    //     // const Orgin = window.location.origin;
    //     // window.location.href = `${Orgin}/agreement/rental/details/${customerId}/${agreementId}`;
    //     history.push({
    //       pathname: `/agreement/rental/details/${customerId}/${agreementId}`,
    //     });
    //     const navEvent = new PopStateEvent('popstate');
    //     window.dispatchEvent(navEvent);
    //   } else {
    //     history.push({
    //       pathname: `/agreement/rental/details/${customerId}?salesLeadId=${salesLeadId}`,
    //     });
    //     const navEvent = new PopStateEvent('popstate');
    //     window.dispatchEvent(navEvent);
    //   }

    //   // communicate to Routes that URL has changed
    //   // const navEvent = new PopStateEvent('popstate');
    //   // window.dispatchEvent(navEvent);
    // } else {
    //   props.triggerMinMaxPopup(captureObjectIndex);
    // }
  };

  function transformInventory(addQuoteItem) {
    const inventoryDetails = addQuoteItem?.itemPricing || [];
    const agreementPricing = addQuoteItem?.agreementPricing || [];

    // Calculate total price for each item and store with original data
    const itemsWithPrice = inventoryDetails.map((detail) => {
      const totalPrice = (detail?.weeklyRate || 0) * (detail?.weeklyTerm || 0);

      return {
        detail,
        totalPrice,
      };
    });
    const quoteRemainingValue = inventoryDetails.reduce((sum, detail) => {
      const value = parseFloat(detail?.remainingValue) || 0;
      return sum + value;
    }, 0);
    console.log(quoteRemainingValue, "quoteRemainingValue");

    const filteredAddItemSearch = addItemSearch?.filter(item =>
      inventoryDetails.some(inv => inv.inventoryId === item.inventoryId));

    const uniqueItems = filteredAddItemSearch.filter((item, index, self) =>
      index === self.findIndex(obj => obj.inventoryId === item.inventoryId)
    );

    const iteamSearchRemainingValue = uniqueItems.reduce((sum, item) => {
      const value = parseFloat(item.remainingValue) || 0;
      return sum + value;
    }, 0);
    console.log(iteamSearchRemainingValue, "iteamSearchRemainingValue");

    setRemainingValue(quoteRemainingValue || iteamSearchRemainingValue);
    // Find the maximum total price
    const maxPrice = Math.max(...itemsWithPrice.map(item => item.totalPrice));

    // Transform items, setting productPrincipal based on price
    return itemsWithPrice.map(({ detail }) => {
      const totalPrice = (detail?.weeklyRate || 0) * (detail?.weeklyTerm || 0);
      const productPrincipal = itemsWithPrice.length === 1 || totalPrice === maxPrice ? 'Y' : 'N';
      const itemSearchValue = uniqueItems?.find(val => val?.inventoryId == detail?.inventoryId);

      return {
        category: itemSearchValue?.itemTypeEs || detail?.departmentEs || '',
        subCategory: itemSearchValue?.itemSubtypeEs || detail?.subDepartmentEs || '',
        productPrincipal,
        rmsItemNumber: detail.rmsItemNumber || '',
        modelNumber: detail?.modelNumber || '',
        weeklyPriceTag: detail?.weeklyRate || '',
        agreementTerms: agreementPricing?.agreementTerm || '',
        agreementScheDule: "semanal",
        desc: detail.inventoryName || ''
      };
    });
  }

  const transformDERequest = (getCustomerResponse: any, decrypteData: any) => {
    const customerResponse = getCustomerResponse?.GetCustomer?.value;
    const primAddress = customerResponse?.addresses?.find((val) => val.addressType === "PRIM");
    const nonPrimAddress = customerResponse?.addresses?.find((val) => val.addressType !== "PRIM");
    const address = primAddress || nonPrimAddress;
    const employement = customerResponse?.employerReferences;
    const isPrimaryPhone = customerResponse?.phones?.find((val) => val.primary === 'Y');
    const notPrimaryPhone = customerResponse?.phones?.find((val) => val.primary !== 'Y');
    const phone = isPrimaryPhone || notPrimaryPhone;
    const transformInventoryData = transformInventory(addGetItemPrice);
    const encodedData = sessionStorage.getItem('storeDetails');
    const storeNumber = sessionStorage.getItem('storeNumber');
    console.log(encodedData, 'encodedData in transform')
    let storeName = '';
    if (encodedData) {
      const decodedData = atob(encodedData);
      const storeDetails = JSON.parse(decodedData);
      console.log(storeDetails, 'storeDetails in transform')
      storeName = storeDetails?.storeName
    }

    const residenceTenureType = customerResponse?.residenceType == 'RENT' ?
      customerResponse?.landlordReferences?.[0]?.residenceTenureTypeDescEs :
      customerResponse?.residenceType == 'OWN' ? customerResponse?.residenceTenureTypeDescEs : customerResponse?.residenceTenureTypeDescEs;

    const request: any = {
      originCountry: 'MX',
      firstName: customerResponse?.firstName,
      lastName: customerResponse?.lastName,
      voterId: customerResponse?.voterId,
      curpId: customerResponse?.curpId,
      maternalLastName: customerResponse?.maternalLastName,
      gender: customerResponse?.genderDescEs,
      maritalStatus: customerResponse?.maritalStatusDescEs,
      dateOfBirth: customerResponse?.dateOfBirthEnc,
      taxId: decrypteData?.taxIdDecr,
      customerId: customerResponse?.customerId,
      storeNumber: storeNumber,
      storeName: storeName,
      globalCustomerId: customerResponse?.globalCustomerId,
      email: customerResponse?.emailAddress,
      imss: customerResponse?.imss || null,
      address: {
        addressType: address?.addressType,
        addressLine1: address?.addressLine1,
        addressLine2: address?.addressLine2 || '',
        externalUnitNumber: address?.exteriorNumber || '',
        city: address?.city,
        postalCode: address?.postalCode,
        state: address?.stateName
      },
      employer: {
        monthlyPayAmount: employement?.[0]?.takeHomePay || '',
        incomeSourceType: employement?.[0]?.incomeSourceDescEs || '',
        jobType: employement?.[0]?.jobTypeDescEs || '',
        companyBusiness: employement?.[0]?.employerName || null,
        position: employement?.[0]?.jobTitle || null,
        laborOld: employement?.[0]?.employmentBeginDate || employement?.[0]?.lengthOfEmploymentYears || null,
        street: employement?.[0]?.addressLine1 || null,
        homeNumber: null,
        homeIntNumber: null,
        suburb: null,
        city: employement?.[0]?.city || null,
        state: employement?.[0]?.state || null,
        phone: employement?.[0]?.employerPhoneNumber || null
      },
      residence: {
        residenceType: customerResponse?.residenceTypeEs || '',
        residenceLengthType: residenceTenureType || customerResponse?.residenceTenureTypeDescEs
      },
      phone: {
        phoneNumber: phone?.phoneNumber,
        phoneType: phone?.phoneType,
        primary: phone?.primary,
        callTimeType: ''
      },
      shoppingCart: {
        products: transformInventoryData
      },
      packageType: (() => {
        if (props.selectedPackage === 'NEW') return 'NEW';
        if (props.selectedPackage || transformInventoryData.length > 1) return 'PRED';
        return '';
      })(),
      contactReferences: customerResponse?.personalReferences?.length > 0
        ? customerResponse.personalReferences.map((ref: any) => ({
            name: ref.firstName && ref.lastName
              ? `${ref.firstName} ${ref.lastName}`
              : ref.firstName || ref.lastName || "",
            phone: ref.phoneNumber || "",
            relationship: ref.relationshipType || "",
            status: ref.active || "",
            address: {
                  addressType: "PRIM",
                  addressLine1: ref.addressLine1 || "",
                  addressLine2: ref.addressLine2 || "",
                  city: ref.city || "",
                  state: ref.state || "",
                  postalCode: ref.postalCode || "",
                  internalUnitNumber: ref.interiorNumber || "",
                  externalUnitNumber: ref.exteriorNumber || "",
                },
          }))
        : []
    }

    // Build packageInformation if a package is selected
    if (props.selectedPackage) {
      const agrPricing = addGetItemPrice?.agreementPricing;
      request.packageInformation = {
        packageId: null,
        shortDesc: props.selectedPackage || null,
        longDesc: props.selectedPackage || null,
        weeklyRate: agrPricing?.agreementRate || null,
        schedule: "SEMANAL",
        term: agrPricing?.agreementTerm ? `${agrPricing.agreementTerm}` : null
      };
    }
    console.log(request, 'after DE request formattion')
    return request
  }

  const buildPackageSelection = () => {
    return (
      <Grid className="">
        <Grid className={classes.textCenter}>
          <Typography>
            {t("Please confirm you have selected the correct package type")}{' '}
            <Typography className={`${classes.mt2} ${classes.fontBold}`}>
              {props.givereceivedpackage}
            </Typography>
          </Typography>
        </Grid>
        <Grid className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.mx1}
            variant="outlined"
            color="primary"
            onClick={() => setopenPackageSelection(false)}
          >
            {t("No")}
          </RACButton>
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => {
              setopenPackageSelection(false);
              minMaxValidator();
            }}
          >
            {t("Yes")}
          </RACButton>
        </Grid>
      </Grid>
    );
  };

  const dEDeclinedBtnFn = () => {
    setDEPopUpOpen({ ...dEPopUpOpen, dEpopUp: false, dEApproved: false, dEDeclined: false, dEOverride: false, overrideLimitExceeded: false })
    const moduleNames = {
      rejected_by_payment_capacity_exceeded: "MX DE Payment Capacity",
      rejected_by_score: "MX DE Score",
      rejected_by_ss: "MX DE Skip Stolen"
    };

    if (moduleNames[approvalStatus]) {
      setModuleName(moduleNames[approvalStatus]);
      setSecondFactorEnabled(true);
      setDeclinePopUp(true);
    } else {
      history.push({ pathname: `/dashboard/homepage` });
    }
  };

  const approvalOkFn = () => {
    const dEData = dEResponse || {};
    const tagData = addGetItemPrice?.agreementPricing;

    if ((Number(dEData?.approvalAmount) >= Number(remainingValue)) &&
      (Number(dEData?.weeklyApprovalAmount) >= Number(tagData?.agreementRate))) {
      setDEPopUpOpen({ ...dEPopUpOpen, dEpopUp: false, dEApproved: false, dEDeclined: false, dEOverride: false, overrideLimitExceeded: false })
      nonMxStoreFn()
    } else {
      setDEPopUpOpen({ ...dEPopUpOpen, dEpopUp: false, dEApproved: false, dEOverride: true, dEDeclined: false, overrideLimitExceeded: false })
    }
  }
  const statusMessage = (): string => {
    switch (approvalStatus) {
      case 'rejected_by_payment_capacity_exceeded':
        return "Rejected by payment Capacity Exceeded";
      case 'rejected_by_score':
        return "Rejected by score";
      case 'rejected_by_ss':
        return "Rejected by SS";
      case 'rejected_by_active_agreements':
        return "Rejected by Active Agreements";
      case 'rejected_by_hard_rules':
        return "Rejected by hard rules";
      default:
        return "Customer profile is not Eligible";
    }

  }
  const dEPopUp = () => {
    const dEData = dEResponse || {};
    return (
      <>
        {dEPopUpOpen.dEApproved ?
          <>
            <Grid style={{ padding: '0% 5% 2% 5%;' }}>
              <Grid style={{ textAlign: 'center', marginBottom: '10px', fontFamily: 'OpenSans-bold' }}>
                <Typography>{t('Decision engine has approved the customer')}</Typography>
              </Grid>
              <Grid style={{ textAlign: 'center', marginBottom: '10px', color: "#4A5174" }}>
                <Typography>{t('Approval Amount')}: <span>${dEData.approvalAmount || 0}</span></Typography>
                <Typography>{t('Weekly Approval Amount')}:  <span>${dEData.weeklyApprovalAmount || 0} </span></Typography>
              </Grid>
              <Grid style={{ textAlign: 'center' }}>
                <RACButton
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    approvalOkFn()
                  }}>
                  {t('OK')}
                </RACButton>
              </Grid>
            </Grid>
          </> : dEPopUpOpen.dEDeclined ?
            <Grid style={{ padding: '0% 5% 2% 5%;' }}>
              <Grid style={{ textAlign: 'center', marginBottom: '10px', fontFamily: 'OpenSans-bold' }}>
                <Typography>{t('Decision engine has declined the customer')}</Typography>
              </Grid>
              <Grid style={{ textAlign: 'center', marginBottom: '10px', color: "#4A5174" }}>
                <Typography>{t(statusMessage())}</Typography>
              </Grid>
              <Grid style={{ textAlign: 'center' }}>
                <RACButton
                  variant="contained"
                  color="primary"
                  onClick={() => { dEDeclinedBtnFn() }}>
                  {t('OK')}
                </RACButton>
              </Grid>
            </Grid> : dEPopUpOpen.dEReason ?
              <Grid style={{ padding: '15px' }}>
                <Typography style={{ marginBottom: '5px' }}>{t('Reason')}</Typography>
                <textarea
                  rows={6}
                  maxLength={256}
                  style={{ resize: "none", width: "100%", border: "1px solid lightgray", borderRadius: '10px', marginBottom: '10px' }}
                  value={overrideReason}
                  onChange={(e: any) => {
                    setOverrideReason(e.target.value);
                  }}
                ></textarea>
                <Grid style={{ textAlign: 'right' }}>
                  <RACButton
                    variant="outlined"
                    color="primary"
                    style={{ marginRight: '10px' }}
                    onClick={() => {
                      setDEPopUpOpen({ ...dEPopUpOpen, dEpopUp: false, dEApproved: false, dEOverride: false, dEDeclined: false })
                    }}
                  >{t('Cancel')}
                  </RACButton>
                  <RACButton
                    variant="contained"
                    color="primary"
                    disabled={overrideReason?.trim() ? false : true}
                    onClick={() => submitBtnClick()
                    }
                  >{t('Submit')}
                  </RACButton>
                </Grid>
              </Grid> : dEPopUpOpen.error ?
                <Grid style={{ padding: '0% 5% 2% 5%;' }}>
                  <Grid style={{ textAlign: 'center', marginBottom: '10px', fontFamily: 'OpenSans-bold' }}>
                    <Typography>{t('Error in processing DE request')}</Typography>
                  </Grid>
                  <Grid style={{ textAlign: 'center' }}>
                    <RACButton
                      variant="contained"
                      color="primary"
                      style={{ marginRight: '10px' }}
                      onClick={() => {
                        setDEPopUpOpen({ ...dEPopUpOpen, dEpopUp: false, dEApproved: false, dEDeclined: false, error: false })
                      }}>
                      {t('OK')}
                    </RACButton>
                  </Grid>
                </Grid> : null
        }
      </>
    )
  }

  const dEOverridePopUp = () => {
    const dEData = dEResponse || {};
    return (
      <>
        <Grid style={{ padding: '0% 5% 2% 5%;' }}>
          <Grid style={{ textAlign: 'center' }}>
            <Typography style={{ fontFamily: 'OpenSans-bold' }}>{t('Override Approval Amount')}</Typography>
          </Grid>
          <Grid style={{ textAlign: 'center', marginBottom: '10px', fontFamily: 'OpenSans-bold' }}>
            <Typography style={{ fontSize: 'small' }}>{t('You can’t proceed with agreement as tag rate is higher than weekly approval amount')}</Typography>
          </Grid>
          <Grid container md={12}>
            <Grid container md={12} style={{ background: 'aliceblue' }}>
              <Grid item md={6}>
                <Typography style={{ textAlign: 'left' }}>{t('Override Limit')}:</Typography>
              </Grid>
              <Grid item md={6}>
                <Typography style={{ textAlign: 'right' }}>
                  {overrideApproval.overrideUsed || 0}/{overrideApproval.overrideLimit || 0}</Typography>
              </Grid>
            </Grid>
            <Grid container md={12} style={{ padding: '5px 5px 0px 5px' }}>
              <Grid item md={6} style={{ textAlign: 'left' }}>
                <Typography>{t('Approval Amount')}:</Typography>
              </Grid>
              <Grid item md={6} style={{ textAlign: 'right' }}>
                <Typography>${dEData.approvalAmount || 0}</Typography>
              </Grid>
            </Grid>
            <Grid container md={12} style={{ padding: '0px 5px 0px 5px' }}>
              <Grid item md={6} style={{ textAlign: 'left' }}>
                <Typography>{t('Weekly Approval Amount')}:</Typography>
              </Grid>
              <Grid item md={6} style={{ textAlign: 'right' }}>
                <Typography>${dEData.weeklyApprovalAmount || 0}</Typography>
              </Grid>
            </Grid>
            <Grid container md={12} style={{ padding: '0px 5px 0px 5px' }}>
              <Grid item md={6} style={{ textAlign: 'left' }}>
                <Typography>{t('Tag Rate')}:</Typography>
              </Grid>
              <Grid item md={6} style={{ textAlign: 'right' }}>
                <Typography>${addGetItemPrice?.agreementPricing?.agreementRate || 0}</Typography>
              </Grid>
            </Grid>
            <Grid container md={12} style={{ padding: '0px 5px 0px 5px' }}>
              <Grid item md={6} style={{ textAlign: 'left' }}>
                <Typography>{t('Remaining Value')}:</Typography>
              </Grid>
              <Grid item md={6} style={{ textAlign: 'right' }}>
                <Typography>${(remainingValue || 0)?.toFixed(2)}</Typography>
              </Grid>
            </Grid>
            {overrideApproval.overrideUsed == 0 ?
              <Grid container md={12} style={{ padding: '10px', border: '1px solid #e75c5c', margin: '10px 0px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <AlterIcon style={{ width: '20px', height: '20px', cursor: 'pointer' }} />
                <Typography style={{ marginLeft: '5px', cursor: 'pointer' }}>{t('Override limit has been exceeded')}
                </Typography>
              </Grid> : null}
          </Grid>
          <Grid style={{ textAlign: 'center' }}>
            <RACButton
              variant="outlined"
              color="primary"
              style={{ marginRight: '10px' }}
              onClick={() => {
                setDEPopUpOpen({ ...dEPopUpOpen, dEpopUp: false, dEApproved: false, dEOverride: false, dEDeclined: false })
              }}
            >{t('Cancel')}
            </RACButton>
            <RACButton
              variant="contained"
              color="primary"
              onClick={() => {
                setDEPopUpOpen({ ...dEPopUpOpen, dEpopUp: true, dEApproved: false, dEDeclined: false, dEOverride: false, dEReason: true, overrideLimitExceeded: false })
              }}
            >{t('Override')}
            </RACButton>
          </Grid>
        </Grid>
      </>
    )
  }

  const dEOverrideLimitExceededPopUp = () => {
    return (
      <>
        <Grid style={{ padding: '20px', textAlign: 'center' }}>
          <Grid style={{ marginBottom: '20px', display: 'flex', justifyContent: 'center' }}>
            <Info style={{ height: '40px', width: '40px', color: '#1976d2' }} />
          </Grid>
          <Grid style={{ marginBottom: '20px' }}>
            <Typography style={{ fontFamily: 'OpenSans-bold', fontSize: '18px', marginBottom: '10px' }}>
              {t('Override limit has been exceeded')}
            </Typography>
            <Typography style={{ fontSize: '14px', color: '#4A5174' }}>
              {t('To proceed enter Call Center User Security Code')}
            </Typography>
          </Grid>
          <Grid style={{ textAlign: 'center' }}>
            <RACButton
              variant="outlined"
              color="primary"
              style={{ marginRight: '10px' }}
              onClick={() => {
                setDEPopUpOpen({ ...dEPopUpOpen, dEpopUp: false, dEApproved: false, dEOverride: true, dEDeclined: false, dEReason: false, overrideLimitExceeded: false })
              }}
            >
              {t('Cancel')}
            </RACButton>
            <RACButton
              variant="contained"
              color="primary"
              onClick={() => {
                setModuleName("DE Override")
                setIsOverrideLimitExceeded(true)
                setSecondFactorEnabled(true)
                setDEPopUpOpen({ ...dEPopUpOpen, dEpopUp: false, dEApproved: false, dEDeclined: false, dEOverride: false, dEReason: false, overrideLimitExceeded: false })
              }}
            >
              {t('Yes, Proceed')}
            </RACButton>
          </Grid>
        </Grid>
      </>
    )
  }

  return (
    <>
      {loaderBundle.masterLoader ? (
        <Grid className={classes.masterLoader}>
          <Grid className={classes.Loader}>
            <CircularProgress />
          </Grid>
        </Grid>
      ) : null}
      <Grid className={classes.fixedBottom}>
        <Grid className={classes.floatLeft}>
          <RACButton
            color="primary"
            variant="outlined"
            className={classes.ms2}
            onClick={() => CancelClick()}
          >
            {t("Cancel")}
          </RACButton>
        </Grid>

        <RACTooltip
          className={classes.tooltipcss}
          classes={{
            tooltip: classes.toolTipStyle,
            arrow: classes.arrowStyle
          }}
          placement="top"
          title={
            buttonController ? "This Customer is not eligible to add this item." : ""
          }
        >
          <Grid className={classes.floatRight}>
            <RACButton
              color="primary"
              variant="contained"
              onClick={() => NextBtnClick()}
              disabled={footerControl || buttonController}
              style={{ marginRight: '4px' }}
            >
              {t("Next")}
            </RACButton>
          </Grid>
        </RACTooltip>
        {agreementVoidStatus.agreementVoidedStatus === false &&
          agreementCreateStatus.agreementCreatedStatus === false ? (
          <Grid className={classes.floatRight}>
            <AddCocustomer
              coCustomerProps={customerId}
              newCoCustomer={newcustomer}
              func={pull_data}
              somethingTrigger={triggerME}
            />
          </Grid>
        ) : null}
        <RACModalCard
          isOpen={openPackageSelection}
          maxWidth="xs"
          borderRadius={'25px !important'}
          //eslint-disable-next-line react/no-children-prop
          children={buildPackageSelection()}
        />
        <RACModalCard
          isOpen={dEPopUpOpen.dEpopUp}
          maxWidth="xs"
          borderRadius={'25px !important'}
          closeIcon={true}
          onClose={() => {
            setDEPopUpOpen({ ...dEPopUpOpen, dEpopUp: false, dEApproved: false, dEOverride: false, dEDeclined: false })
          }}
          title={dEPopUpOpen.dEReason ? 'Overriding' : ''}
          //eslint-disable-next-line react/no-children-prop
          children={dEPopUp()}
        />
        <RACModalCard
          isOpen={dEPopUpOpen.dEOverride}
          maxWidth="xs"
          borderRadius={'25px !important'}
          closeIcon={true}
          onClose={() => {
            setDEPopUpOpen({ ...dEPopUpOpen, dEpopUp: false, dEApproved: false, dEOverride: false, dEDeclined: false })
          }}
          className={classes.dEOverride}
          //eslint-disable-next-line react/no-children-prop
          children={dEOverridePopUp()}
        />
        <RACModalCard
          isOpen={dEPopUpOpen.overrideLimitExceeded}
          maxWidth="xs"
          borderRadius={'25px !important'}
          closeIcon={true}
          onClose={() => {
            setDEPopUpOpen({ ...dEPopUpOpen, dEpopUp: false, dEApproved: false, dEOverride: true, dEDeclined: false, dEReason: false, overrideLimitExceeded: false })
          }}
          //eslint-disable-next-line react/no-children-prop
          children={dEOverrideLimitExceededPopUp()}
        />
        {SecondFactorEnabled === true ? (
          <SecondFactor
            setTwoFactorCancelClick={(value: any) => SLAClose(value)}
            setTwoFactorCompleted={() => SLACompleted()}
            closeSLAClicked={() => SLACancel()}
            moduleName={ModuleName}
            currentRole={coworkerRole || window.localStorage.getItem('currentRole')}
            throwCurrentPage='ItemSearch'
            forceRemoteLogin={isOverrideLimitExceeded}
            remoteLoginTitle={isOverrideLimitExceeded ? t("Please enter the Call Center User security code to continue") : undefined}
          />
        ) : null}
        <RACModalCard
          isOpen={showReferenceWarning}
          maxWidth="xs"
          closeIcon={true}
          onClose={() => setShowReferenceWarning(false)}
          borderRadius={'25px !important'}
        >
          <Grid item md={12} className="px-2">
            <Grid item md={12} className="text-center">
              <Info style={{ height: '25px', width: '25px' }} />

              <Typography
                style={{ marginTop: '18px', marginBottom: '10px', fontSize: '16px' }}
              >
                {`${t("Atleast")} ${isMotorcycleAdded ? referenceDetails?.Motorcycle : referenceDetails?.Rental} ${t("referrals are required to proceed with")} ${t(isMotorcycleAdded ? 'Motorcycle' : 'rental')} ${t("agreement")}`}
              </Typography>
            </Grid>
            <Grid container style={{ justifyContent: 'center' }}>

              <RACButton
                color="primary"
                variant="outlined"
                style={{ marginRight: '20px' }}
                onClick={() => {
                  setShowReferenceWarning(false);
                }}
              >
                {t("Back")}
              </RACButton>

              <RACButton
                color="primary"
                variant="contained"
                style={{ marginRight: '10px' }}
                onClick={() => {
                  history.push({
                    pathname: `/customer/update/${customerId}/customer`,
                  });
                }}
              >
                {t("Add Referrals")}
              </RACButton>
            </Grid>
          </Grid>
        </RACModalCard>
      </Grid>
    </>
  );
};
export default FooterContent;